import React from "react";
import { connect } from "react-redux";
import * as R from "ramda";

import { Div, Span } from "components/Base";

import {
  getSessions,
  getMySessionsTitle,
  getSectionHeaderColor,
  getSectionHeaderFont,
  getSectionHeaderSize
} from "../selectors";

import { actions } from "Portal/PortalHome/model";
import { addS } from "utils/General";

import CSSModules from "react-css-modules";
import css from "./styles.scss";

import StatusCircle from "ui-kit/StatusCircle";
import { H2, H3, TASK_ACTIONS } from "Portal/PortalHome/constants";
import numeral from "numeral";

const decorate = R.compose(
  connect(
    state => ({
      sessions: getSessions(state),
      mySessionsTitle: getMySessionsTitle(state),
      sectionHeaderColor: getSectionHeaderColor(state),
      sectionHeaderFont: getSectionHeaderFont(state),
      sectionHeaderSize: getSectionHeaderSize(state)
    }),
    {
      executeAction: actions.executeAction
    }
  ),
  CSSModules(css)
);

const getIcon = type =>
  R.prop(type)({
    excel: (
      <Div width={25} height={25} ml={1}>
        <img
          alt="portal-icon-people"
          aria-label="portal-icon-people"
          src="https://d2dks4tzxs6xee.cloudfront.net/img/portal-icon-people.png"
          width="25"
          height="25"
        />
      </Div>
    ),
    word: (
      <Div width={25} height={25} ml={1}>
        <img
          alt="portal-icon-task"
          aria-label="portal-icon-task"
          src="https://d2dks4tzxs6xee.cloudfront.net/img/portal-icon-task.png"
          width="25"
          height="25"
        />
      </Div>
    ),
    pdf: (
      <Div width={30} height={30} ml={1}>
        <img
          alt="portal-icon-invoice"
          aria-label="portal-icon-invoice"
          src="https://d2dks4tzxs6xee.cloudfront.net/img/portal-icon-invoice.png"
          width="30"
          height="30"
        />
      </Div>
    )
  }) || (
    <Div width={26} height={26} ml={1}>
      <img
        alt="portal-icon-document"
        aria-label="portal-icon-document"
        src="https://d2dks4tzxs6xee.cloudfront.net/img/portal-icon-document.png"
        width="26"
        height="26"
      />
    </Div>
  );

export const Session = ({ type, executeAction, ...data }) => {
  const {
    status,
    name,
    open_label,
    is_past_due,
    meta = {},
    isSubsession,
    isReadOnly,
    parentStatus
  } = data;

  const {
    friendly_id,
    date,
    location,
    speakers,
    track,
    format,
    level,
    count_of_files,
    count_of_comments,
    chairpersons,
    moderators,
    ceu_credits: ceu
  } = meta;

  const icon = getIcon(type);

  const hideDataUpponStatus =
    parentStatus === "rejected" || parentStatus === "pending";

  return (
    <Div
      display={"column"}
      bg="white"
      px={3}
      py={3}
      bra={3}
      mb={3}
      ml={isSubsession ? 15 : undefined}
      shadow={{
        default: 0,
        hover: 2
      }}
      style={{
        cursor: "pointer",
        border: is_past_due ? "1px solid rgb(245, 159, 0)" : undefined,
        boxShadow: isReadOnly ? "none!important" : undefined
      }}
      onClick={() => {
        return executeAction({
          type: TASK_ACTIONS.OPEN_SESSION_CONTENT_MODAL,
          data
        });
      }}
    >
      <Div
        display={
          status === "approved"
            ? "row.space-between.flex-start"
            : "row.center.center"
        }
        width={1}
        className={css.session}
      >
        <Div
          display={
            status === "approved" || isSubsession
              ? "row.flex-start.flex-start"
              : "row.center.center"
          }
          width={1}
        >
          <Div
            display="row.flex-start.center"
            pt={status === "approved" ? 3 : 0}
            ml={isSubsession ? 5 : 0}
            mt={isSubsession ? 3 : 0}
          >
            {!isSubsession && (
              <>
                {status === "rejected" ? (
                  <StatusCircle status="rejected" size={30} />
                ) : status === "pending" ? (
                  <StatusCircle status="pending" size={30} />
                ) : ["complete", "approved"].includes(status) ? (
                  <StatusCircle status="approved" size={30} />
                ) : is_past_due ? (
                  <StatusCircle status="not-submitted" size={30} />
                ) : (
                  <StatusCircle status="default" size={30} />
                )}
              </>
            )}

            {icon}
          </Div>

          <Div display="column" width={1} ml={2} mr={2}>
            <Div
              fs={5}
              fw={3}
              mb={
                date ||
                speakers ||
                track ||
                format ||
                moderators ||
                chairpersons ||
                level
                  ? 1
                  : 0
              }
              color="black"
            >
              <H3
                style={{
                  margin: "inherit",
                  wordBreak: "break-word",
                  fontSize: "22px"
                }}
              >
                {isSubsession ? R.propOr("", "name", data) : name}
              </H3>
            </Div>
            {(date && !hideDataUpponStatus) || location ? (
              <Div fs={3} mb={3}>
                {date ? date.replace(/(st)|(th)|(nd)|(rd)/, "") : null}
                {date && location ? <>&nbsp;|&nbsp;</> : null}
                {location ? location : null}
              </Div>
            ) : null}
            {speakers && speakers.length && (
              <Div fs={3} mb={track || format || level ? 3 : 0}>
                <Span color="black" fw={3}>
                  Speakers:
                </Span>
                &nbsp;
                {speakers}
              </Div>
            )}
            {chairpersons && chairpersons.length && (
              <Div fs={3} mb={track || format || level ? 3 : 0}>
                <Span color="black" fw={3}>
                  Chairpersons:
                </Span>
                &nbsp;
                {chairpersons}
              </Div>
            )}
            {moderators && moderators.length && (
              <Div fs={3} mb={track || format || level ? 3 : 0}>
                <Span color="black" fw={3}>
                  Moderators:
                </Span>
                &nbsp;
                {moderators}
              </Div>
            )}
            {track ? (
              <Div fs={3} mb={format || level ? 1 : 0}>
                <Span color="black" fw={3}>
                  Track:
                </Span>{" "}
                {track}
              </Div>
            ) : null}
            {format || level || ceu ? (
              <Div fs={3}>
                {format ? (
                  <>
                    <Span color="black" fw={3}>
                      Format:
                    </Span>{" "}
                    {format}
                  </>
                ) : null}
                {format && level ? <>&nbsp;|&nbsp;</> : null}
                {level ? (
                  <>
                    <Span color="black" fw={3}>
                      Level:
                    </Span>{" "}
                    {level}{" "}
                  </>
                ) : null}
                {ceu && (
                  <>
                    <Span color="black" fw={3}>
                      CEU:
                    </Span>{" "}
                    {numeral(ceu).format("0.00")}
                  </>
                )}
              </Div>
            ) : null}
          </Div>
        </Div>

        <Div
          display={
            status === "approved"
              ? "column.flex-start.flex-end"
              : "column.center.flex-end"
          }
          pt={status === "approved" ? 3 : 0}
          style={{
            flexShrink: 0
          }}
          width={140}
          ml={3}
          className={css.session__item}
        >
          <Div fs={3} color="black" textAlign="right" mb={1}>
            {friendly_id}
          </Div>

          <Div fs={3} color="black" textAlign="right">
            {open_label}
          </Div>

          {count_of_files !== null && !isReadOnly && !hideDataUpponStatus ? (
            <Div fs={2} color="#757575" mt={2} textAlign="right">
              {count_of_files ? count_of_files : "No"} file
              {addS(count_of_files)} uploaded
            </Div>
          ) : null}

          {count_of_comments ? (
            <Div
              display="row.flex-start.center"
              fs={2}
              color="#757575"
              mt={2}
              textAlign="right"
            >
              <Div
                bg="blue8"
                mr={1}
                fw={4}
                color="white"
                style={{
                  fontSize: "11px",
                  borderRadius: "100px",
                  padding: "2px 5px"
                }}
              >
                {count_of_comments}
              </Div>{" "}
              comment{addS(count_of_comments)}
            </Div>
          ) : null}
        </Div>
      </Div>
    </Div>
  );
};

const Sessions = ({
  mySessionsTitle,
  sessions,
  executeAction,
  sectionHeaderColor,
  sectionHeaderFont,
  sectionHeaderSize
}) => {
  if (!sessions.length) {
    return null;
  }

  return (
    <Div
      bg="#f2f2f2"
      style={{
        borderRadius: 10,
        padding: "10px 20px",
        marginBottom: "40px",
        width: "100%"
      }}
    >
      <Div display="row.flex-start.center" mb={4}>
        <Div
          className={css.tab}
          fw={4}
          style={{
            fontSize: "30px"
          }}
        >
          <H2
            style={{
              color: sectionHeaderColor,
              fontFamily: sectionHeaderFont,
              fontSize: sectionHeaderSize
            }}
          >
            {mySessionsTitle}
          </H2>
        </Div>
      </Div>
      <Div>
        {R.map(file => {
          const subsessions = R.propOr([], "subsessions", file);
          return (
            <>
              <Session key={file.id} executeAction={executeAction} {...file} />
              {R.map(
                ss => (
                  <Session
                    key={ss.id}
                    parentStatus={file.status}
                    executeAction={executeAction}
                    {...ss}
                  />
                ),
                subsessions
              )}
            </>
          );
        }, sessions)}
      </Div>
    </Div>
  );
};

export default decorate(Sessions);
